/**
 * View component for /user-modules
 *
 * Generic userModule list view. Defaults to 'all' with:
 * this.props.dispatch(userModuleActions.fetchListIfNeeded());
 *
 * NOTE: See /product/views/ProductList.js.jsx for more examples
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as userModuleActions from '../userModuleActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import userModule components
import UserModuleLayout from '../components/UserModuleLayout.js.jsx';
import UserModuleListItem from '../components/UserModuleListItem.js.jsx';

// import userModule css modules
import userModuleStyles from '../userModuleModuleStyles.css';

class UserModuleList extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // fetch a list of your choice
    this.props.dispatch(userModuleActions.fetchListIfNeeded()); // defaults to 'all'
  }

  render() {
    const { userModuleStore } = this.props;

    /**
     * Retrieve the list information and the list items for the component here.
     *
     * NOTE: if the list is deeply nested and/or filtered, you'll want to handle
     * these steps within the mapStoreToProps method prior to delivering the
     * props to the component.  Othwerwise, the render() action gets convoluted
     * and potentially severely bogged down.
     */

    // get the userModuleList meta info here so we can reference 'isFetching'
    const userModuleList = userModuleStore.lists ? userModuleStore.lists.all : null;

    /**
     * use the reducer getList utility to convert the all.items array of ids
     * to the actual userModule objetcs
     */
    const userModuleListItems = userModuleStore.util.getList("all");

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */
    const isEmpty = !userModuleListItems || !userModuleList;

    return (
      <UserModuleLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h1> User Module List
                <Link className="yt-btn small u-pullRight" to={'/user-modules/new'}> NEW User Module </Link>
              </h1>
              <hr/>
              { isEmpty ?
                (userModuleListItems && userModuleList.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: userModuleList.isFetching ? 0.5 : 1 }}>
                  <ul>
                    {userModuleListItems.map((userModule, i) =>
                      <UserModuleListItem key={userModule._id + i} userModule={userModule} />
                    )}
                  </ul>
                </div>
              }
            </div>
          </section>
        </div>
      </UserModuleLayout>
    )
  }
}

UserModuleList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    userModuleStore: store.userModule
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UserModuleList)
);



// WEBPACK FOOTER //
// modules/userModule/views/UserModuleList.js.jsx